import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";

// ✅ Import background and icons
import bgImg from "../../images/bg/industries-bg02.png";
import icon01 from "../../images/icon/carousel_insta.png";
import icon02 from "../../images/icon/carousel_tiktok.png";
import icon03 from "../../images/icon/carousel_youtube.png";
import icon04 from "../../images/icon/carousel_facebook.png";
import icon05 from "../../images/icon/carousel_telegram.png";
import icon06 from "../../images/icon/carousel_spotify.png";
import icon07 from "../../images/icon/carousel_x.png";

const IndustriesSection: React.FC = () => {
  useEffect(() => {
    // ✅ Set background dynamically (optional)
    const section = document.querySelector<HTMLElement>(".industries.bg-wrap");
    if (section) {
      section.style.backgroundImage = `url(${bgImg})`;
    }
  }, []);

  // Platforms we support
  const industries = [
    { icon: icon01, title: "Instagram" },
    { icon: icon02, title: "TikTok" },
    { icon: icon03, title: "YouTube" },
    { icon: icon04, title: "Facebook" },
    { icon: icon05, title: "Telegram" },
    { icon: icon06, title: "Spotify" },
    { icon: icon07, title: "Twitter / X" },
  ];

  return (
    <section className="industries pb-165 bg_img bg-wrap">
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-50">
          <span className="sub-title mb-15">Platforms We Serve</span>
          <h2 className="title">Cheap SMM services for every platform</h2>
        </div>
      </div>

      <div className="xb-industries-wrapper d-inline-block">
        <Marquee
          direction="right"
          speed={40}
          gradient={false}
          pauseOnHover={true}
          className="marquee-right"
        >
          <div className="xb-industries-inner ul_li">
            {industries.map((item, index) => (
              <div className="xb-industries-item xb-border" key={index}>
                <div className="xb-icon">
                  <img src={item.icon} alt={item.title} />
                </div>
                <h3 className="xb-title">{item.title}</h3>
              </div>
            ))}
          </div>
        </Marquee>
      </div>
    </section>
  );
};

export default IndustriesSection;
